<ul class="action-collection--list">
  <li *ngFor="let item of collection">
    <app-view
      [align]="ViewAlign.CENTER"
      [justify]="ViewJustify.SPACE_BETWEEN"
      [gap]="Spacing.MEDIUM_SMALL"
      [spacingBottom]="Spacing.MEDIUM_SMALL"
    >
      <app-view [direction]="ViewDirection.COLUMN" [gap]="Spacing.X_SMALL">
        <app-text [size]="titleSize">{{ item.title }}</app-text>
        <app-text
          [size]="TextSize.BODY_1"
          [weight]="TextWeight.REGULAR"
          [height]="TextHeight.SMALLER"
          [color]="TextColor.NEUTRAL_6"
          >{{ item.subTitle }}</app-text
        >
      </app-view>
      <app-button
        *ngIf="item.label"
        [size]="ButtonSize.X_SMALL"
        [type]="action"
        (handleClick)="onAction(item)"
        [spacingBottom]="Spacing.NONE"
      >
        {{ item.label }}
      </app-button>
    </app-view>
  </li>
</ul>
